import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Shield } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';

const StrictModeCard = ({ strictMode, onToggle, actionLoading }) => (
  <Card>
    <CardHeader>
      <CardTitle className="flex items-center space-x-2">
        <Shield className="w-5 h-5" /><span>Strict Security Mode</span>
      </CardTitle>
      <CardDescription>Require email confirmation for logins from new devices</CardDescription>
    </CardHeader>
    <CardContent className="space-y-4">
      <div className="flex items-center justify-between p-4 bg-slate-50 rounded-lg">
        <div className="flex-1">
          <p className="font-medium text-slate-900">New Device Login Protection</p>
          <p className="text-sm text-slate-600 mt-1">When enabled, you'll need to confirm via email before logging in from a new device or browser.</p>
        </div>
        <label className="relative inline-flex items-center cursor-pointer ml-4">
          <input type="checkbox" checked={strictMode} onChange={onToggle} disabled={actionLoading} className="sr-only peer" />
          <div className="w-11 h-6 bg-gray-300 peer-focus:outline-hidden peer-focus:ring-4 peer-focus:ring-emerald-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-emerald-600"></div>
        </label>
      </div>
      <Alert className={strictMode ? "bg-amber-50 border-amber-200" : "bg-blue-50 border-blue-200"}>
        <AlertDescription className={strictMode ? "text-amber-800" : "text-blue-800"}>
          {strictMode ? (
            <><strong>Enhanced Protection Active:</strong> New device logins will be blocked until you confirm via email. This adds extra security but may cause inconvenience when using new devices.</>
          ) : (
            <><strong>Standard Protection:</strong> You'll receive email alerts for new device logins, but they won't be blocked. This balances security with convenience.</>
          )}
        </AlertDescription>
      </Alert>
    </CardContent>
  </Card>
);

export default StrictModeCard;
